export default __webpack_public_path__ + "static/media/element_14.b9765ce1.jpg";